import { object, string, ref } from "yup"

export const loginSchema = object({
  email: string().required("required").email("email"),
  password: string().required("required")
})

export const login2FASchema = loginSchema.concat(
  object({
    otp_attempt: string().required("required")
  })
)

export const changePasswordSchema = object({
  current_password: string().nullable(),
  password: string().required("required"),
  password_confirmation: string()
    .required("required")
    .oneOf([ref("password"), null], "match"),
  reset_password_token: string().nullable(),
  confirmation_token: string().nullable()
})

export const forgotPasswordSchema = object({
  email: string().required("required").email("email")
})

export const confirmWithPasswordSchema = object({
  password: string().required("required")
})
